import classNames from 'classnames';
import React from 'react';

import {TooltipPlacement, TooltipWrapper} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface Props {
  buttonStyle: ButtonStyle;
  className?: string;
  disabled: boolean;
  size: ButtonSize;
  tooltipTitle?: string | null;
  onClick: () => void;
}

export default function ExecuteButton(props: Props): JSX.Element {
  return (
    <TooltipWrapper tooltipTitle={props.tooltipTitle} tooltipPlacement={TooltipPlacement.BOTTOM}>
      <div className={classNames('u-display-inline-block', props.className)}>
        <Button
          buttonStyle={props.buttonStyle}
          disabled={props.disabled}
          onClick={props.onClick}
          size={props.size}
          text="Execute"
          dataTestAttrs={{
            component: 'ExecuteButton',
            element: 'root',
          }}
        />
      </div>
    </TooltipWrapper>
  );
}
ExecuteButton.defaultProps = {
  disabled: false,
  size: ButtonSize.SMALL,
};
